import React from 'react';
import { GRAMMAR_CATEGORIES } from '../../constants/grammarCategories';

// Vícenásobný výběr gramatických kategorií z pevného seznamu — admin vybírá
// zaškrtnutím, vlastní hodnotu napsat nemůže.
// value: pole vybraných kategorií (pro jistotu zvládne i comma-string ze starých dat).
// onChange: vždy dostane nové pole.
const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (typeof value === 'string') {
    return value.split(',').map((s) => s.trim()).filter(Boolean);
  }
  return [];
};

const GrammarCategoriesField = ({ value, onChange }) => {
  const selected = toArray(value);

  const toggle = (cat) => {
    if (selected.includes(cat)) {
      onChange(selected.filter((c) => c !== cat));
    } else {
      onChange([...selected, cat]);
    }
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {GRAMMAR_CATEGORIES.map((cat) => {
        const isOn = selected.includes(cat);
        return (
          <label
            key={cat}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '6px 10px',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              userSelect: 'none',
              border: `1.5px solid ${isOn ? '#2563eb' : '#d1d5db'}`,
              backgroundColor: isOn ? '#eff6ff' : '#fff',
              color: isOn ? '#1e40af' : '#374151',
            }}
          >
            <input
              type="checkbox"
              checked={isOn}
              onChange={() => toggle(cat)}
              style={{ cursor: 'pointer' }}
            />
            {cat}
          </label>
        );
      })}
    </div>
  );
};

export default GrammarCategoriesField;

// Hotová konfigurace editovatelného pole pro AdminTable. Hodnota se drží jako
// pole kategorií; serialize/deserialize jen zajistí, že to pole vždycky je.
export const grammarCategoriesField = {
  key: 'grammar_categories',
  type: 'custom',
  label: 'Grammar Categories',
  deserialize: (value) => (Array.isArray(value) ? value : value ? [value] : []),
  serialize: (value) => (Array.isArray(value) ? value : []),
  renderEdit: (value, onChange) => (
    <GrammarCategoriesField value={value} onChange={onChange} />
  ),
};
